<div class="container">
  <div
    fxLayout="column"
    fxLayoutAlign="space-around center"
    class="stepInfoContainer"
  >
    <div class="titleTab">
      {{ "TAB_STEPPER.DEVICE_AND_DATATYPE" | translate }}
    </div>
    <button
      *ngIf="isATable || isADigital"
      mat-raised-button
      class="primaryBtn"
      [disabled]="selectedDeviceList.length < 1 || dataTypeSelected.length < 1"
      (click)="generateChartElement()"
    >
      {{ "TAB_STEPPER.GENERATE_WIDGET" | translate }}
    </button>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-around center">
    <button class="sausageSelectBtn" [matMenuTriggerFor]="menu">
      <div>
        <p>{{ "TAB_STEPPER.SELECT_FACTORY" | translate }}</p>
        <mat-menu #menu class="factorySelectionMenu userMenu">
          <div *ngFor="let factory of factoryCollection?.collection">
            <mat-checkbox
              [checked]="factory.selected"
              class="mat-menu-item factoryMenu"
              (click)="selectFactoryEvent(factory)"
              >{{ factory.name }}</mat-checkbox
            >
          </div>
        </mat-menu>
      </div>
    </button>
    <div *ngIf="factoriesSelected?.collection?.length < 1">
      <div class="text-center warning-factories">
        <h3>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h3>
        <p>{{ "TAB_STEPPER.CLICK_TO_ADD_FACTORY" | translate }}</p>
      </div>
    </div>
    <mat-tab-group
      multi
      class="accordionMobile"
      animationDuration="0"
      *ngIf="factoriesSelected?.collection?.length > 0"
      [selectedIndex]="selectedFactory.value"
      (selectedIndexChange)="selectedFactory.setValue($event)"
    >
      <div *ngFor="let factory of factoriesSelected?.collection; let i = index">
        <mat-tab [label]="factory.descripcion">
          <app-alarma-devices-hierarchi
            [title]="title[i]"
            [deviceChildrenList]="childrens[i]"
            (deviceItemSelected)="selectedDeviceGraphItem($event)"
            (deviceItemUnSelected)="unSelectedDeviceGraphItem($event)"
            (deviceItemNavegate)="navigate($event, i)"
            (goBackOnDevices)="goBack(i)"
            [loadingChildren]="loading[i]"
            [isRoot]="isRoot[i]"
          >
          </app-alarma-devices-hierarchi>
        </mat-tab>
      </div>
    </mat-tab-group>

    <div *ngIf="finishOne" class="accordionMobile">
      <div class="text-center warning-factories titleTab">
        {{ "TAB_STEPPER.DATATYPES" | translate }}
      </div>
      <!-- <div class="space10"></div> -->
      <div class="containerMatChips">
        <p
          *ngIf="
            dataTypeSelected !== null &&
            dataTypeSelected !== undefined &&
            dataTypeSelected.length > 0
          "
        >
          {{ "TAB_STEPPER.DATATYPE_SELECTED" | translate }}
        </p>
        <p
          title="Este campo es requerido"
          *ngIf="
            dataTypeSelected === null ||
            dataTypeSelected === undefined ||
            dataTypeSelected.length == 0
          "
          class="text-center"
        >
          {{ "TAB_STEPPER.NO_DATATYPES_SELECTED" | translate }}
          <span title="Este campo es requerido" class="required">*</span>
        </p>
        <div
          *ngIf="dataTypeSelected !== null && dataTypeSelected !== undefined"
        >
          <div *ngFor="let item of dataTypeSelected">
            <mat-chip
              class="unselectable btnForm margin4"
              *ngIf="item?.name !== null"
              >{{ item?.name }}
            </mat-chip>
          </div>
        </div>
      </div>
      <!-- <div class="space20"></div> -->
      <div class="heightDatatype" *ngIf="availableSecond">
        <!-- TODO: Revivar incompatibilidad del tipado -->
        <!-- <app-alarma-datatype-navigate
          [dataTypeSelectedCollection]="dataTypeSelected"
          [dataTypeChildrenList]="dataTypeTree"
          [deviceDatatype]="devicesSelectedSubject | async"
          (datatypeItemSelected)="selectedDatatype($event)"
          (datatypeItemUnSelected)="unSelectedDatatype($event)"
          [loadingChildren]="loading"
        >
        </app-alarma-datatype-navigate> -->
        <app-alarma-datatype-navigate
          [dataTypeSelectedCollection]="dataTypeSelected"
          [dataTypeChildrenList]="dataTypeTree"
          [deviceDatatype]="devicesSelectedSubject | async"
          (datatypeItemSelected)="selectedDatatype($event)"
          (datatypeItemUnSelected)="unSelectedDatatype($event)"
        >
        </app-alarma-datatype-navigate>
      </div>
    </div>
  </div>
</div>
